var _defs, _rect, _path, _path2, _path3, _circle, _path4, _circle2, _path5, _circle3, _path6, _circle4, _path7, _circle5, _path8, _circle6, _path9, _circle7, _path0, _circle8, _path1, _circle9, _path10, _circle0, _path11, _circle1, _path12, _circle10, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductiveHours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#ed0000;}.c{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3.54,
    ry: 3.54
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M24.01,25.1c-.6,0-1.09-.49-1.1-1.09l-.02-10.05c0-.6.49-1.1,1.09-1.1h0c.6,0,1.09.49,1.1,1.09l.02,10.05c0,.6-.49,1.1-1.09,1.1h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M32.29,25.13h0l-8.28-.04c-.6,0-1.09-.5-1.09-1.1,0-.6.49-1.09,1.1-1.09h0l8.28.04c.6,0,1.09.5,1.09,1.1,0,.6-.49,1.09-1.1,1.09Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24,44.52c-5.48,0-10.63-2.13-14.51-6.01-3.87-3.87-6.01-9.03-6.01-14.51s2.13-10.63,6.01-14.51c3.88-3.87,9.03-6.01,14.51-6.01s10.63,2.13,14.51,6.01c3.87,3.88,6.01,9.03,6.01,14.51s-2.13,10.63-6.01,14.51c-3.88,3.87-9.03,6.01-14.51,6.01ZM24,6.11C14.14,6.11,6.11,14.14,6.11,24s8.02,17.89,17.89,17.89,17.89-8.02,17.89-17.89S33.86,6.11,24,6.11Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 9.53,
    r: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24,10.97c-.79,0-1.44-.64-1.44-1.44s.64-1.44,1.44-1.44,1.44.64,1.44,1.44-.64,1.44-1.44,1.44ZM24,8.97c-.31,0-.56.25-.56.56s.25.56.56.56.56-.25.56-.56-.25-.56-.56-.56Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.76,
    cy: 11.47,
    r: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.77,12.9c-.12,0-.25-.02-.37-.05-.37-.1-.68-.34-.87-.67-.4-.69-.16-1.57.53-1.96.69-.4,1.57-.16,1.96.53h0c.4.69.16,1.57-.53,1.96-.22.13-.47.19-.72.19ZM16.76,10.91c-.1,0-.19.02-.28.07-.27.15-.36.5-.21.77.07.13.2.22.34.26.14.04.3.02.43-.06.27-.15.36-.5.21-.77-.1-.18-.29-.28-.49-.28Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.47,
    cy: 16.76,
    r: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.47,18.2c-.24,0-.49-.06-.72-.19-.33-.19-.57-.5-.67-.87-.1-.37-.05-.76.14-1.09.19-.33.5-.57.87-.67.37-.1.76-.05,1.09.14h0c.33.19.57.5.67.87.1.37.05.76-.14,1.09-.27.46-.75.72-1.25.72ZM11.47,16.2s-.1,0-.15.02c-.14.04-.27.13-.34.26-.07.13-.09.28-.06.43.04.14.13.27.26.34.13.07.28.09.43.06.14-.04.27-.13.34-.26.07-.13.09-.28.06-.43s-.13-.27-.26-.34h0c-.09-.05-.18-.08-.28-.08Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.53,
    cy: 24,
    r: 1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53,25.44c-.79,0-1.44-.64-1.44-1.44s.64-1.44,1.44-1.44,1.44.64,1.44,1.44-.64,1.44-1.44,1.44ZM9.53,23.44c-.31,0-.56.25-.56.56s.25.56.56.56.56-.25.56-.56-.25-.56-.56-.56Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.47,
    cy: 31.24,
    r: 1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.47,32.67c-.5,0-.98-.26-1.25-.72-.4-.69-.16-1.57.53-1.96h0c.33-.19.72-.24,1.09-.14.37.1.68.34.87.67.19.33.24.72.14,1.09-.1.37-.34.68-.67.87-.23.13-.47.19-.72.19ZM11.19,30.75c-.27.15-.36.5-.21.77s.5.36.77.21c.13-.07.22-.2.26-.34.04-.14.02-.3-.06-.43-.07-.13-.2-.22-.34-.26-.14-.04-.3-.02-.43.06h0Z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.76,
    cy: 36.53,
    r: 1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.76,37.97c-.25,0-.49-.07-.72-.19-.69-.4-.92-1.28-.53-1.96.19-.33.5-.57.87-.67.37-.1.76-.05,1.09.14.33.19.57.5.67.87.1.37.05.76-.14,1.09-.19.33-.5.57-.87.67-.12.03-.25.05-.37.05ZM16.77,35.97s-.1,0-.15.02c-.14.04-.27.13-.34.26-.15.27-.06.61.21.77.13.07.28.09.43.06.14-.04.27-.13.34-.26.07-.13.09-.28.06-.43-.04-.14-.13-.27-.26-.34-.09-.05-.18-.08-.28-.08Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 38.47,
    r: 1
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24,39.91c-.79,0-1.44-.64-1.44-1.44s.64-1.44,1.44-1.44,1.44.64,1.44,1.44-.64,1.44-1.44,1.44ZM24,37.91c-.31,0-.56.25-.56.56s.25.56.56.56.56-.25.56-.56-.25-.56-.56-.56Z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.24,
    cy: 36.53,
    r: 1
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M31.24,37.97c-.12,0-.25-.02-.37-.05-.37-.1-.68-.34-.87-.67-.19-.33-.24-.72-.14-1.09.1-.37.34-.68.67-.87.33-.19.72-.24,1.09-.14.37.1.68.34.87.67.19.33.24.72.14,1.09-.1.37-.34.68-.67.87-.22.13-.47.19-.72.19ZM31.23,35.97c-.1,0-.19.03-.28.08-.13.07-.22.2-.26.34-.04.14-.02.3.06.43h0c.07.13.2.22.34.26.14.04.3.02.43-.06.13-.07.22-.2.26-.34.04-.14.02-.3-.06-.43-.07-.13-.2-.22-.34-.26-.05-.01-.1-.02-.15-.02Z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.53,
    cy: 31.24,
    r: 1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.53,32.67c-.24,0-.49-.06-.72-.19-.33-.19-.57-.5-.67-.87-.1-.37-.05-.76.14-1.09.19-.33.5-.57.87-.67.37-.1.76-.05,1.09.14.69.4.92,1.28.53,1.96-.27.46-.75.72-1.25.72ZM36.53,30.67s-.1,0-.15.02c-.14.04-.27.13-.34.26-.07.13-.09.28-.06.43.04.14.13.27.26.34h0c.27.15.61.06.77-.21s.06-.61-.21-.77c-.09-.05-.18-.08-.28-.08Z"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 38.47,
    cy: 24,
    r: 1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.47,25.44c-.79,0-1.44-.64-1.44-1.44s.64-1.44,1.44-1.44,1.44.64,1.44,1.44-.64,1.44-1.44,1.44ZM38.47,23.44c-.31,0-.56.25-.56.56s.25.56.56.56.56-.25.56-.56-.25-.56-.56-.56Z"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.53,
    cy: 16.76,
    r: 1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.53,18.2c-.5,0-.98-.26-1.25-.72-.19-.33-.24-.72-.14-1.09.1-.37.34-.68.67-.87.33-.19.72-.24,1.09-.14.37.1.68.34.87.67.4.69.16,1.57-.53,1.96h0c-.23.13-.47.19-.72.19ZM37.03,17.63h0,0ZM36.53,16.2c-.1,0-.19.03-.28.08-.13.07-.22.2-.26.34-.04.14-.02.3.06.43s.2.22.34.26c.14.04.3.02.43-.06.13-.07.22-.2.26-.34.04-.14.02-.3-.06-.43-.07-.13-.2-.22-.34-.26-.05-.01-.1-.02-.15-.02Z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.24,
    cy: 11.47,
    r: 1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.23,12.9c-.25,0-.49-.07-.72-.19-.69-.4-.92-1.28-.53-1.96.4-.69,1.28-.92,1.96-.53.33.19.57.5.67.87s.05.76-.14,1.09c-.19.33-.5.57-.87.67-.12.03-.25.05-.37.05ZM31.24,10.91s-.1,0-.15.02c-.14.04-.27.13-.34.26-.15.27-.06.61.21.77.13.07.28.09.43.06.14-.04.27-.13.34-.26h0c.07-.13.09-.28.06-.43-.04-.14-.13-.27-.26-.34-.09-.05-.18-.08-.28-.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductiveHours);
export default __webpack_public_path__ + "static/media/productive-hours.79618378734102f47d5bef989d789637.svg";
export { ForwardRef as ReactComponent };